export default __webpack_public_path__ + "cb65767a7a46ec7ea547f21f738082d7.png";